import { defineStore } from "pinia";

export interface Patch24SelectedLicense {
  _id: string;
  name: string;
  count: string;
  url: string;
  startdate: string;
  enddate: string;
  updatedBy: string;
  dateUpdated: number;
  sartdate: string;
  enabled_patches: string[];
  patchAll: boolean;
  active: boolean;
  customerId: string;
  GlobalConfiguration: {
    UpdateDeadline: number;
    GracePeriod: number;
    PatchingDelay: number;
    EnableNotifications: boolean;
    NotificationFrequency: number;
    NotificationFrequencyPostDeadline: number;
    PatchAllApps: boolean;
    AppsSelected: string[];
    Commands: Array<{
      action: string;
      licenseId: string;
      appId: string;
      name: string;
      version: string;
      scope: string;
      type: string;
      uuid: string;
      status: string;
      created?: string;
      createdBy?: string;
      groupID?: string;
    }>;
  };
  Configurations: Array<{
    ConfigurationID: string;
    ConfigurationName: string;
    Commands: Array<{
      action: string;
      licenseId: string;
      appId: string;
      name: string;
      version: string;
      scope: string;
      groupID?: string;
      type: string;
      created: string;
      createdBy: string;
      uuid: string;
      status: string;
    }>;
  }>;
  __v: number;
}

export interface Patch24Device {
  _id: string;
  serial: string;
  lastContact: string;
  computerName: string;
  username: string;
  fullName: string;
  model: string;
  updatesAvailableCount: number;
  Computer_Name: string;
  Serial_Number: string;
  Model: string;
  patchLastContact: string;
}

export interface Patch24State {
  selectedLicense: Patch24SelectedLicense | Record<string, never>;
  alerts: any[];
  devices: Patch24Device[];
  commands: any[];
  appsList: any[];
  commandsUpdated: Date;
}

export const patch24Store = defineStore("patch24", {
  state: (): Patch24State => ({
    selectedLicense: {},
    alerts: [],
    devices: [],
    commands: [],
    appsList: [],
    commandsUpdated: new Date(),
  }),
});
